import React, {
    useContext
} from 'react';
import { ExperimentCtx } from '../../../contexts/experiments';
import LoginButton from '../../Utils/LoginButton';
import CtaVersionA from './CtaVersionA';
import { EGTNL_TESTS_KUMO } from '../../../../server/api/abacus/constants';
import CtaVersionB from './CtaVersionB';

function EgHeaderCta() {
    const { experimentEvaluations } = useContext(ExperimentCtx);
    const {
        [EGTNL_TESTS_KUMO.ULX_CL_STICKY_ABC]: AbcVersion
    } = experimentEvaluations || {};
    if (AbcVersion === 1) {
        return (<CtaVersionA />);
    }
    if (AbcVersion === 2) {
        return (<CtaVersionB />);
    }
    return (
        <LoginButton display />
    );
}

export default EgHeaderCta;
